// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__20Ols","inputDescription":"styles_inputDescription__2rEC-"};